import { render, staticRenderFns } from "./activity2Period2023.vue?vue&type=template&id=7db43133&scoped=true&"
import script from "./activity2Period2023.vue?vue&type=script&lang=js&"
export * from "./activity2Period2023.vue?vue&type=script&lang=js&"
import style0 from "./activity2Period2023.vue?vue&type=style&index=0&id=7db43133&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db43133",
  null
  
)

export default component.exports